import { render, staticRenderFns } from "./VisionHeader.vue?vue&type=template&id=3bd1d106&"
import script from "./VisionHeader.vue?vue&type=script&lang=js&"
export * from "./VisionHeader.vue?vue&type=script&lang=js&"
import style0 from "./VisionHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports